interface FandomWithId {
  id?: number;
}

/**
 * Extracts fandom IDs from main fandom and additional fandoms
 * Filters out null/undefined values
 */
export const extractFandomIds = (
  mainFandom?: FandomWithId | null,
  additionalFandoms?: FandomWithId[] | null,
): number[] => {
  return [mainFandom?.id, ...(additionalFandoms?.map((fandom) => fandom.id) ?? [])].filter(
    (id): id is number => id != null,
  );
};
